<template>
  <main class="success">
    <section class="wrapper section">
      <div class="success-content">
        <font-awesome-icon class="error-icon" :icon="'exclamation-triangle'" />
        <h1 class="success-title">Não é possível realizar o pagamento dessa assinatura</h1>

        <p class="success-text">{{ reason }}</p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'SubscriptionError',
  data() {
    return {
      reason: sessionStorage.error_reason
    };
  },
  mounted() {
    sessionStorage.clear();
  }
};
</script>
